(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ae-ceramic-editorial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.ae-ceramic__light-toggle');
    if (!button) return;
    const card = button.closest('.ae-ceramic__card');
    if (!card) return;
    const isOff = card.classList.toggle('ae-ceramic__off');
    button.setAttribute('aria-pressed', String(!isOff));
    button.querySelector('.ae-ceramic__switch-label').textContent = isOff ? button.dataset.off : button.dataset.on;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atease-community-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ae-community-videos')) {
    customElements.define('ae-community-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        this.rail = this.querySelector('.aec__rail');
        this.videos = [...this.querySelectorAll('video')];
        this.visible = new Set();
        this.manualPaused = new Set();
        this.manualPlaying = new Set();
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.previous = this.querySelector('.aec__previous');
        this.next = this.querySelector('.aec__next');
        this.videos.forEach(video => {
          video.muted = true;
          video.defaultMuted = true;
          video.pause();
          const button = video.closest('button');
          const label = () => {
            button.setAttribute('aria-pressed', String(!video.paused));
            button.setAttribute('aria-label', (video.paused ? 'Play video: ' : 'Pause video: ') + button.dataset.caption);
          };
          video.addEventListener('play', label, options);
          video.addEventListener('pause', label, options);
          button.addEventListener('click', () => {
            if (video.paused) {
              this.manualPaused.delete(video);
              this.manualPlaying.add(video);
              this.hydrate(video);
              video.play().catch(label);
            } else {
              this.manualPlaying.delete(video);
              this.manualPaused.add(video);
              video.pause();
            }
          }, options);
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.2) this.visible.add(entry.target);
              else this.visible.delete(entry.target);
            });
            this.syncPlayback();
          }, {threshold:[0,0.2,0.6,1]});
          this.videos.forEach(video => this.observer.observe(video));
        } else {
          this.videos.forEach(video => this.visible.add(video));
          this.syncPlayback();
        }
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.rail.addEventListener('scroll', () => this.updateNavigation(), {...options,passive:true});
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          }
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        window.addEventListener('resize', () => this.updateNavigation(), options);
        this.addEventListener('shopify:block:select', event => {
          const card = [...this.querySelectorAll('.aec__moment')].find(item => item.dataset.blockId === event.detail.blockId);
          if (card) this.rail.scrollTo({left:card.getBoundingClientRect().left - this.rail.getBoundingClientRect().left + this.rail.scrollLeft,behavior:'instant'});
        }, options);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
          this.resizeObserver.observe(this.rail);
        }
        this.updateNavigation();
      }
      hydrate(video) {
        if (video.dataset.loaded) return;
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        video.dataset.loaded = 'true';
        video.load();
      }
      syncPlayback() {
        this.videos.forEach(video => {
          const shouldPlay = !document.hidden && this.visible.has(video) && ((this.autoplayEnabled && !this.manualPaused.has(video)) || this.manualPlaying.has(video));
          if (shouldPlay) {
            this.hydrate(video);
            if (video.paused) video.play().catch(() => {});
          } else if (!video.paused) video.pause();
        });
      }
      move(direction) {
        const first = this.rail.querySelector('.aec__moment');
        if (!first) return;
        const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).gap);
        this.rail.scrollBy({left:direction * step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      updateNavigation() {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        this.previous.disabled = this.rail.scrollLeft < 4;
        this.next.disabled = this.rail.scrollLeft >= max - 4;
      }
      disconnectedCallback() {
        if (!this.abort) return;
        this.abort.abort();
        this.abort = null;
        if (this.observer) this.observer.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.videos.forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summer-event-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-autumn-event-page]');

    roots.forEach((root) => {
      if (root.dataset.aepReady === 'true') return;
      root.dataset.aepReady = 'true';

      const topGrid = root.querySelector('[data-aep-products-top]');
      const moreGrid = root.querySelector('[data-aep-products-more]');
      const moreSection = root.querySelector('[data-aep-more]');
      const editCards = Array.from(root.querySelectorAll('[data-aep-edit-product]'));
      const filterButtons = Array.from(root.querySelectorAll('[data-aep-filter]'));
      const productBreakpoint = window.matchMedia('(min-width: 750px)');
      let activeFilter = 'all';

      const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'GBP'
      }).format(cents / 100);

      const showEdit = (filter) => {
        activeFilter = filter;
        const topLimit = productBreakpoint.matches ? 9 : 8;
        const matches = editCards.filter((card) => filter === 'all' || card.dataset.editCategory === filter);

        editCards.forEach((card) => { card.hidden = true; });
        matches.forEach((card, index) => {
          card.hidden = false;
          (index < topLimit ? topGrid : moreGrid).appendChild(card);
        });

        moreSection.hidden = matches.length <= topLimit;
        filterButtons.forEach((button) => {
          const active = button.dataset.aepFilter === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          showEdit(button.dataset.aepFilter);
          if (button.closest('.aep-edits')) {
            root.querySelector('.aep-shop').scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      productBreakpoint.addEventListener('change', () => showEdit(activeFilter));

      const readProduct = (card) => {
        const json = card && card.querySelector('[data-aep-product-json]');
        if (!json) return null;
        try {
          return JSON.parse(json.textContent);
        } catch (error) {
          return null;
        }
      };

      const hydrateImages = (container) => {
        container.querySelectorAll('img[data-src]').forEach((image) => {
          if (!image.getAttribute('src') || image.getAttribute('src').startsWith('data:image/gif')) {
            image.setAttribute('src', image.dataset.src);
          }
        });
      };

      const setSelected = (cards, selectedCard) => {
        cards.forEach((card) => {
          const selected = card === selectedCard;
          card.classList.toggle('is-selected', selected);
          const button = card.querySelector('.aep-product-select');
          if (button) button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      };

      const fillVariantSelect = (field, select, product) => {
        const variants = product ? product.variants.filter((variant) => variant.available) : [];
        select.replaceChildren();

        variants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.title === 'Default Title' ? 'Standard' : variant.title;
          option.dataset.price = String(variant.price);
          select.appendChild(option);
        });

        field.hidden = variants.length <= 1;
        select.disabled = variants.length === 0;
        return variants.length > 0;
      };

      const initializePanel = (panel) => {
        const mainCards = Array.from(panel.querySelectorAll('.aep-product-shell--main'));
        const companionCards = Array.from(panel.querySelectorAll('.aep-product-shell--companion'));
        const stage = panel.querySelector('[data-aep-main-stage]');
        const chooser = panel.querySelector('[data-aep-main-chooser]');
        const changeButton = panel.querySelector('[data-aep-change-main]');
        const title = panel.querySelector('[data-aep-pair-title]');
        const status = panel.querySelector('[data-aep-pair-status]');
        const mainField = panel.querySelector('[data-aep-main-variant-field]');
        const companionField = panel.querySelector('[data-aep-companion-variant-field]');
        const mainSelect = panel.querySelector('[data-aep-main-variant]');
        const companionSelect = panel.querySelector('[data-aep-companion-variant]');
        const pricing = panel.querySelector('[data-aep-pair-pricing]');
        const saveCopy = pricing.querySelector('[data-aep-save-copy]');
        const savePercent = pricing.querySelector('[data-aep-save-percent]');
        const mainPriceOutput = pricing.querySelector('[data-aep-main-price]');
        const companionPriceOutput = pricing.querySelector('[data-aep-companion-price]');
        const originalTotalOutput = pricing.querySelector('[data-aep-original-total]');
        const pairPriceOutput = pricing.querySelector('[data-aep-pair-price]');
        const addButton = panel.querySelector('[data-aep-add-pair]');

        let selectedMain = mainCards[0] || null;
        let selectedCompanion = companionCards[0] || null;

        const visibleCompanions = () => companionCards.filter((card) => !card.hidden);

        const updatePricing = () => {
          const mainPrice = Number(mainSelect.selectedOptions[0]?.dataset.price || 0);
          const companionPrice = Number(companionSelect.selectedOptions[0]?.dataset.price || 0);
          const discountPercent = Math.min(100, Math.max(0, Number(pricing.dataset.discountPercent) || 0));
          const originalTotal = mainPrice + companionPrice;
          const discountMultiplier = (100 - discountPercent) / 100;
          const pairPrice = Math.round(mainPrice * discountMultiplier) + Math.round(companionPrice * discountMultiplier);

          mainPriceOutput.textContent = formatMoney(mainPrice);
          companionPriceOutput.textContent = formatMoney(companionPrice);
          originalTotalOutput.textContent = formatMoney(originalTotal);
          pairPriceOutput.textContent = formatMoney(pairPrice);
          savePercent.textContent = `${discountPercent}%`;
          saveCopy.hidden = discountPercent === 0;
          pricing.hidden = !(mainPrice && companionPrice);
        };

        const updateSummary = (message = '') => {
          const mainProduct = readProduct(selectedMain);
          const companionProduct = readProduct(selectedCompanion);
          title.replaceChildren();
          title.removeAttribute('aria-label');

          if (mainProduct && companionProduct) {
            const mainItem = document.createElement('span');
            mainItem.className = 'aep-pair-title__item';
            mainItem.dataset.index = '01';
            mainItem.innerHTML = '<span class="aep-pair-title__role">Main light</span>';
            const mainName = document.createElement('span');
            mainName.className = 'aep-pair-title__name';
            mainName.textContent = mainProduct.title;
            mainItem.appendChild(mainName);

            const join = document.createElement('span');
            join.className = 'aep-pair-title__join';
            join.textContent = 'paired with';

            const companionItem = document.createElement('span');
            companionItem.className = 'aep-pair-title__item';
            companionItem.dataset.index = '02';
            companionItem.innerHTML = '<span class="aep-pair-title__role">Complementary light</span>';
            const companionName = document.createElement('span');
            companionName.className = 'aep-pair-title__name';
            companionName.textContent = companionProduct.title;
            companionItem.appendChild(companionName);

            title.append(mainItem, join, companionItem);
            title.setAttribute('aria-label', `${mainProduct.title} + ${companionProduct.title}`);
          }
          status.textContent = message;

          const mainAvailable = fillVariantSelect(mainField, mainSelect, mainProduct);
          const companionAvailable = fillVariantSelect(companionField, companionSelect, companionProduct);
          addButton.disabled = !(mainAvailable && companionAvailable);
          updatePricing();
        };

        const updateCompanions = () => {
          const mainProduct = readProduct(selectedMain);
          let shown = 0;

          companionCards.forEach((card) => {
            const product = readProduct(card);
            const shouldShow = Boolean(product && mainProduct && product.id !== mainProduct.id && shown < (productBreakpoint.matches ? 9 : 8));
            card.hidden = !shouldShow;
            if (shouldShow) shown += 1;
          });

          if (!selectedCompanion || selectedCompanion.hidden) {
            selectedCompanion = visibleCompanions()[0] || null;
          }
          setSelected(companionCards, selectedCompanion);
        };

        const selectMain = (card, message = '') => {
          selectedMain = card;
          setSelected(mainCards, selectedMain);

          const themeCard = card.querySelector('.t4s-product');
          if (themeCard) {
            stage.replaceChildren(themeCard.cloneNode(true));
            hydrateImages(stage);
          }

          updateCompanions();
          chooser.hidden = true;
          changeButton.setAttribute('aria-expanded', 'false');
          changeButton.querySelector('.aep-change-main__icon').textContent = '+';
          updateSummary(message);
        };

        const selectCompanion = (card, message = '') => {
          selectedCompanion = card;
          setSelected(companionCards, selectedCompanion);
          updateSummary(message);
        };

        mainCards.forEach((card) => {
          card.querySelector('[data-aep-select-main]').addEventListener('click', () => selectMain(card, 'Pair updated'));
        });

        companionCards.forEach((card) => {
          card.querySelector('[data-aep-select-companion]').addEventListener('click', () => selectCompanion(card, 'Pair updated'));
        });

        changeButton.addEventListener('click', () => {
          const open = chooser.hidden;
          chooser.hidden = !open;
          changeButton.setAttribute('aria-expanded', open ? 'true' : 'false');
          changeButton.querySelector('.aep-change-main__icon').textContent = open ? '\u2212' : '+';
        });

        mainSelect.addEventListener('change', updatePricing);
        companionSelect.addEventListener('change', updatePricing);
        productBreakpoint.addEventListener('change', () => {
          updateCompanions();
          updateSummary();
        });

        addButton.addEventListener('click', async () => {
          if (!mainSelect.value || !companionSelect.value) return;

          addButton.disabled = true;
          status.textContent = 'Adding pair...';

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [
                  { id: Number(mainSelect.value), quantity: 1 },
                  { id: Number(companionSelect.value), quantity: 1 }
                ]
              })
            });

            if (!response.ok) {
              const error = await response.json();
              throw new Error(error.description || 'Unable to add this pair');
            }

            status.textContent = 'Pair added to cart';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));

            const discountCode = pricing.dataset.discountCode.trim();
            if (discountCode) {
              const routesRoot = window.Shopify?.routes?.root || '/';
              const cartPath = `${routesRoot}cart`;
              window.location.assign(`${routesRoot}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(cartPath)}`);
              return;
            }
          } catch (error) {
            status.textContent = error.message || 'Unable to add this pair';
          } finally {
            addButton.disabled = false;
          }
        });

        updateCompanions();
        updateSummary();
      };

      const panels = Array.from(root.querySelectorAll('[data-aep-pair-panel]'));
      panels.forEach(initializePanel);

      root.querySelectorAll('[data-aep-pair-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const id = tab.dataset.aepPairTab;
          root.querySelectorAll('[data-aep-pair-tab]').forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((panel) => { panel.hidden = panel.dataset.aepPairPanel !== id; });
        });
      });

      showEdit('all');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
